// noinspection DuplicatedCode

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinKaryawanCuti = createAsyncThunk(
  "karyawan/getMinKaryawanCuti",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getKaryawanMinCuti",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMinKaryawan = createAsyncThunk(
  "karyawan/getMinKaryawan",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getKaryawanMin",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const GetKaryawanMinV2 = createAsyncThunk(
  "karyawan/GetKaryawanMinV2",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getKaryawanMinV2",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getImageKaryawan = createAsyncThunk(
  "karyawan/getImageKaryawan",
  async ({ PhotoUUID }, thunkAPI) => {
    try {
      const response = await axios.post(
        `process.env.REACT_APP_API_URLkaryawanImage/${PhotoUUID}`,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getKaryawan = createAsyncThunk(
  "karyawan/get",
  async ({ start, count, search, statusFilter }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    formData.append("StatusFilter", statusFilter || "1");
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getHomeKaryawan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getDetailKaryawan = createAsyncThunk(
  "karyawan/getDetail",
  async ({ Nik }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getDetailKaryawan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMenuSaldoKaryawan = createAsyncThunk(
  "karyawan/getMenuSaldoKaryawan",
  async ({ Nik }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMenuSaldoKaryawan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertKaryawan = createAsyncThunk(
  "karyawan/insert",
  async (
    {
      Nik,
      NamaKaryawan,
      TipeKaryawanID,
      BisnisUnitID,
      TempatLahir,
      TanggalLahir,
      Warganegara,
      JenisKelamin,
      Agama,
      GolonganDarah,
      Alamat,
      ProvinsiID,
      KotaID,
      NoTlpn,
      NoHp,
      LevelPendidikan,
      Suku,
      StatusPerkawinan,
      StatusPajak,
      TanggalMasuk,
      JabatanID,
      GolonganID,
      BagianID,
      LokasiTugasID,
      SistemGaji,
      NoRekeningBank,
      BankID,
      PemilikBank,
      NoKTP,
      NPWP,
      BPJS,
      LokasiPenerimaan,
      PhotoUUID,
      email,
      KartuKeluarga,
      Status,
      PIN,
      TanggalMulaiKontrak,
      TanggalAkhirKontrak,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("NamaKaryawan", NamaKaryawan);
    formData.append("TipeKaryawanID", TipeKaryawanID);
    formData.append("BisnisUnitID", BisnisUnitID);
    formData.append("TempatLahir", TempatLahir);
    formData.append("TanggalLahir", TanggalLahir);
    formData.append("Warganegara", Warganegara);
    formData.append("JenisKelamin", JenisKelamin);
    formData.append("Agama", Agama);
    formData.append("GolonganDarah", GolonganDarah);
    formData.append("Alamat", Alamat);
    formData.append("ProvinsiID", ProvinsiID);
    formData.append("KotaID", KotaID);
    formData.append("NoTlpn", NoTlpn);
    formData.append("NoHp", NoHp);
    formData.append("LevelPendidikan", LevelPendidikan);
    formData.append("Suku", Suku);
    formData.append("StatusPerkawinan", StatusPerkawinan);
    formData.append("StatusPajak", StatusPajak);
    formData.append("TanggalMasuk", TanggalMasuk);
    formData.append("JabatanID", JabatanID);
    formData.append("GolonganID", GolonganID);
    formData.append("BagianID", BagianID);
    formData.append("LokasiTugasID", LokasiTugasID);
    formData.append("SistemGaji", SistemGaji);
    formData.append("NoRekeningBank", NoRekeningBank);
    formData.append("BankID", BankID);
    formData.append("PemilikBank", PemilikBank);
    formData.append("NoKTP", NoKTP);
    formData.append("NPWP", NPWP);
    formData.append("BPJS", BPJS);
    formData.append("LokasiPenerimaan", LokasiPenerimaan);
    formData.append("PhotoUUID", PhotoUUID);
    formData.append("email", email);
    formData.append("KartuKeluarga", KartuKeluarga);
    formData.append("Status", Status);
    formData.append("PIN", PIN);
    if (TanggalMulaiKontrak && TanggalAkhirKontrak) {
      formData.append("TanggalMulaiKontrak", TanggalMulaiKontrak);
      formData.append("TanggalAkhirKontrak", TanggalAkhirKontrak);
    }
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertKaryawan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      // WAJIB return — tanpa return thunk dianggap "berhasil" dgn payload kosong
      // sehingga kegagalan simpan tak pernah terlihat.
      return thunkAPI.rejectWithValue(
        e.response?.data || { message: e.message || "Koneksi ke server gagal" }
      );
    }
  }
);

export const updateKaryawan = createAsyncThunk(
  "karyawan/update",
  async (
    {
      Nik,
      NamaKaryawan,
      TipeKaryawanID,
      BisnisUnitID,
      TempatLahir,
      TanggalLahir,
      Warganegara,
      JenisKelamin,
      Agama,
      GolonganDarah,
      Alamat,
      ProvinsiID,
      KotaID,
      NoTlpn,
      NoHp,
      LevelPendidikan,
      Suku,
      StatusPerkawinan,
      StatusPajak,
      TanggalMasuk,
      JabatanID,
      GolonganID,
      BagianID,
      LokasiTugasID,
      SistemGaji,
      NoRekeningBank,
      BankID,
      PemilikBank,
      NoKTP,
      NPWP,
      BPJS,
      LokasiPenerimaan,
      PhotoUUID,
      email,
      KartuKeluarga,
      Status,
      PIN,
      TKontrakKerjaID,
      TanggalMulaiKontrak,
      TanggalAkhirKontrak,
    },
    thunkAPI
  ) => {
    let formData = new FormData();

    formData.append("KartuKeluarga", KartuKeluarga);
    formData.append("Nik", Nik);
    formData.append("NamaKaryawan", NamaKaryawan);
    formData.append("TipeKaryawanID", TipeKaryawanID);
    formData.append("BisnisUnitID", BisnisUnitID);
    formData.append("TempatLahir", TempatLahir);
    formData.append("TanggalLahir", TanggalLahir);
    formData.append("Warganegara", Warganegara);
    formData.append("JenisKelamin", JenisKelamin);
    formData.append("Agama", Agama);
    formData.append("GolonganDarah", GolonganDarah);
    formData.append("Alamat", Alamat);
    formData.append("ProvinsiID", ProvinsiID);
    formData.append("KotaID", KotaID);
    formData.append("NoTlpn", NoTlpn);
    formData.append("NoHp", NoHp);
    formData.append("LevelPendidikan", LevelPendidikan);
    formData.append("Suku", Suku);
    formData.append("StatusPerkawinan", StatusPerkawinan);
    formData.append("StatusPajak", StatusPajak);
    formData.append("TanggalMasuk", TanggalMasuk);
    formData.append("JabatanID", JabatanID);
    formData.append("GolonganID", GolonganID);
    formData.append("BagianID", BagianID);
    formData.append("LokasiTugasID", LokasiTugasID);
    formData.append("SistemGaji", SistemGaji);
    formData.append("NoRekeningBank", NoRekeningBank);
    formData.append("BankID", BankID);
    formData.append("PemilikBank", PemilikBank);
    formData.append("NoKTP", NoKTP);
    formData.append("NPWP", NPWP);
    formData.append("BPJS", BPJS);
    formData.append("LokasiPenerimaan", LokasiPenerimaan);
    formData.append("PhotoUUID", PhotoUUID);
    formData.append("email", email);
    formData.append("Status", Status);
    formData.append("PIN", PIN);
    if (TanggalMulaiKontrak && TanggalAkhirKontrak) {
      formData.append("TKontrakKerjaID", TKontrakKerjaID || "");
      formData.append("TanggalMulaiKontrak", TanggalMulaiKontrak);
      formData.append("TanggalAkhirKontrak", TanggalAkhirKontrak);
    }
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateKaryawan",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      // WAJIB return — tanpa return thunk dianggap "berhasil" dgn payload kosong
      // sehingga kegagalan simpan tak pernah terlihat.
      return thunkAPI.rejectWithValue(
        e.response?.data || { message: e.message || "Koneksi ke server gagal" }
      );
    }
  }
);
export const getKaryawanReport = createAsyncThunk(
  "getKaryawanReport/get",
  async (obj, thunkAPI) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "hrd/karyawan/lap",
        obj,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const getKaryawanReportDetail = createAsyncThunk(
  "getKaryawanReportDetail/get",
  async (obj, thunkAPI) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "hrd/karyawan/lap/detail",
        obj,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
export const resetKaryawanSlice = createAsyncThunk(
  "resetKaryawanSlice/update",
  async ({}, thunkAPI) => {
    return true;
  }
);
export const resetKaryawanDetailSlice = createAsyncThunk(
  "resetKaryawanDetailSlice/update",
  async ({}, thunkAPI) => {
    return true;
  }
);
const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  minDataKaryawan: [],
  isMinKaryawanFetching: false,
  isMinKaryawanSuccess: false,
  isMinKaryawanError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  detailData: [],
  isGetDetailFetching: false,
  isGetDetailSuccess: false,
  isGetDetailError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
  isGetSaldoKaryawanFetching: false,
  isGetSaldoKaryawanSuccess: false,
  isGetSaldoKaryawanError: false,
  minKaryawan: [],

  report: [],
  reportDetail: null,
  isGetReport: false,
  isGetReportDetail: false,
};

export const karyawanSlice = createSlice({
  name: "karyawan",
  initialState,
  reducers: {},
  extraReducers: {
    [getKaryawanReport.fulfilled]: (state, { payload }) => {
      state.report = payload.data;
      state.isGetReport = true;
      state.message = payload.message;
      return state;
    },
    [getKaryawanReport.rejected]: (state, { payload }) => {
      state.isGetReport = false;
    },
    [getKaryawanReport.pending]: (state) => {
      state.isGetReport = false;
    },

    [getKaryawanReportDetail.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.reportDetail = payload.data;
        state.message = payload.message;
      }
      state.isGetReportDetail = true;
      return state;
    },
    [getKaryawanReportDetail.rejected]: (state, { payload }) => {
      state.isGetReportDetail = false;
    },
    [getKaryawanReportDetail.pending]: (state) => {
      state.isGetReportDetail = false;
    },
    [resetKaryawanDetailSlice.pending]: (state) => {
      state.isGetReportDetail = false;
    },
    [getMenuSaldoKaryawan.fulfilled]: (state, { payload }) => {
      state.isGetSaldoKaryawanFetching = false;
      state.isGetSaldoKaryawanSuccess = true;
      state.SaldoKaryawanData = payload.data;
      state.message = payload.message;
      return state;
    },
    [getMenuSaldoKaryawan.rejected]: (state, { payload }) => {
      state.isGetSaldoKaryawanFetching = false;
      state.isGetSaldoKaryawanError = true;
      state.errorMessage = payload.message;
    },
    [getMenuSaldoKaryawan.pending]: (state) => {
      state.isGetSaldoKaryawanFetching = true;
    },

    [getMinKaryawanCuti.fulfilled]: (state, { payload }) => {
      state.isMinKaryawanFetching = false;
      state.isMinKaryawanSuccess = true;
      state.minDataCuti = payload.data;
      return state;
    },
    [getMinKaryawanCuti.rejected]: (state, { payload }) => {
      state.isMinKaryawanFetching = false;
      state.isMinKaryawanError = true;
      state.errorMessage = payload.message;
    },
    [getMinKaryawanCuti.pending]: (state) => {
      state.isMinKaryawanFetching = true;
    },

    [getMinKaryawan.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinKaryawan.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload.message;
    },
    [getMinKaryawan.pending]: (state) => {
      state.isMinFetching = true;
    },

    [GetKaryawanMinV2.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minKaryawan = payload.data;
      return state;
    },
    [GetKaryawanMinV2.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload.message;
    },
    [GetKaryawanMinV2.pending]: (state) => {
      state.isMinFetching = true;
    },

    [getKaryawan.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getKaryawan.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getKaryawan.pending]: (state) => {
      state.isGetFetching = true;
    },

    [getImageKaryawan.fulfilled]: (state, { payload }) => {
      state.isGetImageFetching = false;
      state.isGetImageSuccess = true;
      state.dataImage = payload.data;
      state.message = payload.message;
      return state;
    },
    [getImageKaryawan.rejected]: (state, { payload }) => {
      state.isGetImageFetching = false;
      state.isGetImageError = true;
      state.errorMessage = payload.message;
    },
    [getImageKaryawan.pending]: (state) => {
      state.isGetImageFetching = true;
    },

    [getDetailKaryawan.fulfilled]: (state, { payload }) => {
      state.isGetDetailFetching = false;
      state.isGetDetailSuccess = true;
      state.detailData = payload.data;
      state.message = payload.message;
      return state;
    },
    [getDetailKaryawan.rejected]: (state, { payload }) => {
      state.isGetDetailFetching = false;
      state.isGetDetailError = true;
      state.errorMessage = payload.message;
    },
    [getDetailKaryawan.pending]: (state) => {
      state.isGetDetailFetching = true;
    },

    // INSERT
    // Tanpa window.location.reload: halaman menyegarkan daftar sendiri setelah
    // simpan sukses, dan modal tetap terbuka bila gagal.
    [insertKaryawan.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.isInsertError = false;
      state.message = payload?.message;
      return state;
    },
    [insertKaryawan.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = false;
      state.isInsertError = true;
      state.errorMessage = payload?.message || "";
    },
    [insertKaryawan.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateKaryawan.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.isUpdateError = false;
      state.message = payload?.message;
      return state;
    },
    [updateKaryawan.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message || "";
    },
    [updateKaryawan.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const karyawanSelector = (state) => state.karyawan;
